import axios from "axios";
import * as helper from "../utils/helper";
import store from "../../../admin/src/store";
export default {
    apiUrl() {
        return helper.server.apiURL;
    },

    baseUrl() {
        return helper.server.baseURL;
    },
    async post(url, data = {}, headers = {}) {
        return await axios.post(url, data, {headers: headers})
    },

    async postAuth(url, data = {}, headers = {}) {
        try {
            return await axios.post(url, data, {
                headers: Object.assign(this.getAuthHeader(), headers)
            });
        } catch (e) {
            if (e.response && e.response.status === 401) {
                await this.refreshToken();
                return await axios.post(url, data, {
                    headers: Object.assign(this.getAuthHeader(), headers)
                });
            } else {
                throw e;
            }
        }
    },

    async refreshToken() {
        try {
            const response = await axios.post(`${this.apiUrl()}/refresh_token`, {}, {headers: this.getAuthHeader()})
            const token = response.data && response.data.data && response.data.data.token || null;
            localStorage.setItem('jwt', token);
            return token;
        } catch (e) {
            if (e.response && e.response.status === 403) {
                delete localStorage.user;
                delete localStorage.jwt;
            }
            throw e;
        }
    },

    async getAuth(url, data = {}, headers = {}) {
        try {
            return await axios.get(url, {data, headers: Object.assign(this.getAuthHeader(), headers)});
        } catch (e) {
            console.log(e)
            if (e.response.status === 401) {
                store.commit('logOutUser');
                return await axios.get(url, {data, headers: Object.assign(this.getAuthHeader(), headers)});
            } else {
                throw e;
            }
        }
    },

    async get(url, data = {}, headers = {}) {
        return await axios.get(url, {data, headers});
    },

    getAuthHeader() {
        return {Authorization: `Bearer ${localStorage.getItem('jwt')}`};
    },

    async delete(url, data = {}, headers = {}) {
        return await axios.delete(url, {data, headers});
    },
    async deleteAuth(url, data = {}, headers = {}) {
        try {
            return await axios.delete(url, {data, headers: Object.assign(this.getAuthHeader(), headers)});
        } catch (e) {
            if (e.response.status === 401) {
                await this.refreshToken();
                return await axios.get(url, {data, headers: Object.assign(this.getAuthHeader(), headers)});
            } else {
                throw e;
            }
        }
    },
    // Tried to drag a map pin this method is required for that
    async putAuth(url, data = {}, headers = {}) {
        try {
            return await axios.put(url, data, {
                headers: Object.assign(this.getAuthHeader(), headers)
            });
        } catch (e) {
            if (e.response && e.response.status === 401) {
                await this.refreshToken();
                return await axios.put(url, data, {
                    headers: Object.assign(this.getAuthHeader(), headers)
                });
            } else {
                throw e;
            }
        }
    },
}
